/**************************************************************************************
 *  Objetivo: SubTitulo Sobre
 *  Autor: Luiz Gustavo
 *  Data: 17/01/2023
 *  Versão: 1.0
 **************************************************************************************/

const SubTituloSobre = ({ subtitulo }) => {
    return (
        <div className="subtitulo-sobre">
            <div className="box-subtitulo"></div>
            <h2>{subtitulo}</h2>
        </div>
    )
}

export default SubTituloSobre;
